/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSttBenchmarkSampleRequest } from '../../models/create-stt-benchmark-sample-request';
import { CreateSttBenchmarkSampleResult } from '../../models/create-stt-benchmark-sample-result';

export interface ApiAdminBenchmarksBenchmarkIdSttSamplesPost$Params {
  benchmarkId: string;
      body?: CreateSttBenchmarkSampleRequest
}

export function apiAdminBenchmarksBenchmarkIdSttSamplesPost(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarksBenchmarkIdSttSamplesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSttBenchmarkSampleResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksBenchmarkIdSttSamplesPost.PATH, 'post');
  if (params) {
    rb.path('benchmarkId', params.benchmarkId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSttBenchmarkSampleResult>;
    })
  );
}

apiAdminBenchmarksBenchmarkIdSttSamplesPost.PATH = '/api/Admin/benchmarks/{benchmarkId}/stt-samples';
